import React from 'react'
import CheckoutContainer from '../../../../Components/Applications/ECommerce/Checkout'

export default function Checkout() {
  return (
    <div className='page-body checkout'>
      <CheckoutContainer />
    </div>
  )
}